import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { FC } from 'react';

interface Props {
  icon: React.ReactElement;
  title: string;
  listItems: string[];
}

const useStyles = makeStyles({
  list: {
    marginBlockStart: 0,
    paddingInlineStart: '16px',
    '& > li': {
      listStyle: 'square',
    },
  },
  icon: {
    fontSize: '1.5rem',
  },
});

const OverviewList: FC<Props> = ({ icon, title, listItems }) => {
  const styles = useStyles();

  return (
    <>
      <Grid alignItems="center" spacing={1} container>
        <Grid className={styles.icon} item>
          {icon}
        </Grid>
        <Grid item>
          <Typography variant="subtitle1">
            <strong>{title}</strong>
          </Typography>
        </Grid>
      </Grid>
      <ul className={styles.list}>
        {listItems.map((item, index) => (
          <li key={index}>
            <Typography variant="body2">{item}</Typography>
          </li>
        ))}
      </ul>
    </>
  );
};

export default OverviewList;
